import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { NavLink, useLocation } from "react-router-dom";

function Header() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [menu, setMenu] = useState(true);
  const [Down, setDown] = useState(true);

  const toggleNavbar = () => {
    setMenu(!menu);
  };

  const classOne = menu
    ? "main-menu menu-mobile"
    : "main-menu menu-mobile show";

  const classOnes = menu
    ? "btn-show-menu-mobile menubar menubar--squeeze"
    : "btn-show-menu-mobile menubar menubar--squeeze is-active";

  const toggleDown = () => {
    setDown(!Down);
  };

  const classTwo = Down ? "mega-menu-link" : "mega-menu-link active";

  const classThree = Down ? "mega-submenu" : "mega-submenu active";

  const location = useLocation();
  const currentPath = location.pathname;

  const isServicesActive = [
    "/application-development",
    "/website-design-development",
    "/mobile-application-development",
    "/digital-marketing",
    "/graphic-design",
    "/software-maintenance",
  ].some((path) => location.pathname.startsWith(path));

  return (
    <>
      <header id="masthead" className="header prt-header-style-01">
        <div id="site-header-menu" className="site-header-menu">
          <div className="site-header-menu-inner prt-stickable-header">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="site-navigation d-flex align-items-center justify-content-between">
                    <div className="site-branding">
                      <h1>
                        <NavLink
                          className="home-link"
                          to="/"
                          title="Altech"
                          rel="home"
                        >
                          <img
                            id="logo-img"
                            height={50}
                            width={200}
                            className="img-fluid auto_size"
                            src="images/logo.png"
                            alt="logo-img"
                          />
                        </NavLink>
                      </h1>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="menu-link">
                        <div className={classOnes}>
                          <span className="menubar-box" onClick={toggleNavbar}>
                            <span className="menubar-inner" />
                          </span>
                        </div>
                        <nav className={classOne} id="menu">
                          <ul className="menu">
                            <li
                              className={`mega-menu-item ${
                                currentPath === "/" ? "active" : ""
                              }`}
                            >
                              <NavLink to="/">Home</NavLink>
                            </li>
                            <li
                              className={`mega-menu-item ${
                                currentPath === "/about" ? "active" : ""
                              }`}
                            >
                              <NavLink to="/about">About us</NavLink>
                            </li>

                            <li
                              className={`mega-menu-item ${
                                isServicesActive ? "active" : ""
                              }`}
                            >
                              <a
                                href="#"
                                className={classTwo}
                                onClick={toggleDown}
                              >
                                Services
                              </a>
                              <ul className={classThree}>
                                <li
                                  className={
                                    currentPath === "/application-development"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <NavLink to="/application-development">
                                    Application Development
                                  </NavLink>
                                </li>
                                <li
                                  className={
                                    currentPath ===
                                    "/website-design-development"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <NavLink to="/website-design-development">
                                    Web Design & Development
                                  </NavLink>
                                </li>
                                <li
                                  className={
                                    currentPath ===
                                    "/mobile-application-development"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <NavLink to="/mobile-application-development">
                                    Mobile Application Development
                                  </NavLink>
                                </li>
                                <li
                                  className={
                                    currentPath === "/digital-marketing"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <NavLink to="/digital-marketing">
                                    Digital Marketing
                                  </NavLink>
                                </li>
                                <li
                                  className={
                                    currentPath === "/graphic-design"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <NavLink to="/graphic-design">
                                    Graphic Design
                                  </NavLink>
                                </li>
                                <li
                                  className={
                                    currentPath === "/software-maintenance"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <NavLink to="/software-maintenance">
                                    Software Maintenance
                                  </NavLink>
                                </li>
                              </ul>
                            </li>
                            <li
                              className={`mega-menu-item ${
                                currentPath === "/blog" ? "active" : ""
                              }`}
                            >
                              <NavLink to="/blog">Blog</NavLink>
                            </li>
                            <li
                              className={`mega-menu-item ${
                                currentPath === "/contact" ? "active" : ""
                              }`}
                            >
                              <NavLink to="/contact">Contact us</NavLink>
                            </li>
                          </ul>
                        </nav>
                      </div>
                      <div className="side-menu-container d-flex align-items-center">
                        <div className="header_call">
                          <span className="call-text">Contact No: </span>
                          <a href="tel:1234567890" className="call_btn">
                            (+91 8328 473 790)
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <ToastContainer />
    </>
  );
}

export default Header;
